/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, PlanMetadataUpdateDTO, PlansDTO } from '../fastAPI.schemas'

/**
 * Changes a saved plan's name, comment and/or tags without re-uploading its PDF.
 * @summary Update Plan Metadata
 */
export const updatePlanMetadata = (
  projectGuid: string,
  planGuid: string,
  planMetadataUpdateDTO: PlanMetadataUpdateDTO,
) => {
  return customInstance<PlansDTO>({
    url: `/projects/${projectGuid}/plans/${planGuid}/metadata`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: planMetadataUpdateDTO,
  })
}

export const useUpdatePlanMetadataMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanMetadata>>,
    TError,
    { projectGuid: string; planGuid: string; data: PlanMetadataUpdateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlanMetadata>>,
  TError,
  { projectGuid: string; planGuid: string; data: PlanMetadataUpdateDTO },
  TContext
> => {
  const mutationKey = ['updatePlanMetadata']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlanMetadata>>,
    { projectGuid: string; planGuid: string; data: PlanMetadataUpdateDTO }
  > = props => {
    const { projectGuid, planGuid, data } = props ?? {}

    return updatePlanMetadata(projectGuid, planGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/plans/{planGuid}/metadata` },
    {
      operationId: 'update_plan_metadata_projects__project_guid__plans__plan_guid__metadata_patch',
      operationName: 'updatePlanMetadata',
    },
  )

  return customOptions
}

export type UpdatePlanMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlanMetadata>>
>
export type UpdatePlanMetadataMutationBody = PlanMetadataUpdateDTO
export type UpdatePlanMetadataMutationError = HTTPValidationError

/**
 * @summary Update Plan Metadata
 */
export const useUpdatePlanMetadata = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlanMetadata>>,
    TError,
    { projectGuid: string; planGuid: string; data: PlanMetadataUpdateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlanMetadata>>,
  TError,
  { projectGuid: string; planGuid: string; data: PlanMetadataUpdateDTO },
  TContext
> => {
  const mutationOptions = useUpdatePlanMetadataMutationOptions(options)

  return useMutation(mutationOptions)
}
